export interface CardPricingProps {
	hasFees: boolean
	totalPrice?: string
	baseRent?: string
	leaseTerm?: string
	hasDisclaimerSymbol: boolean
	preText?: string
}

/** "From …" pricing summary shared by the plan and community card footers. */
export function CardPricing ({
	hasFees,
	totalPrice,
	baseRent,
	leaseTerm,
	hasDisclaimerSymbol,
	preText = 'From'
}: CardPricingProps) {
	const disclaimer = hasDisclaimerSymbol ? '*' : ''

	if (hasFees) {
		return (
			<div className='spaces:@container spaces:flex spaces:flex-col spaces:flex-1 spaces:min-w-0'>
				<div className='spaces:flex spaces:items-baseline spaces:whitespace-nowrap'>
					<span className='spaces:text-14/16 spaces:font-default spaces:text-content-3 spaces:mr-4'>{preText}</span>
					<span className='spaces:text-18/24 spaces:font-strong spaces:text-content-1'>{totalPrice}</span>
					<span className='spaces:text-14/16 spaces:font-default spaces:text-content-3'>
						/mo{disclaimer}
					</span>
				</div>
				{(baseRent || leaseTerm) && (
					<div className='spaces:flex spaces:flex-col spaces:gap-4 spaces:@pricing-detail:flex-row spaces:@pricing-detail:items-center spaces:@pricing-detail:gap-8 spaces:text-14/16 spaces:font-default spaces:text-content-3'>
						{baseRent && <span className='spaces:whitespace-nowrap'>{baseRent} Base Rent</span>}
						{baseRent && leaseTerm && (
							<span className='spaces:hidden spaces:@pricing-detail:block spaces:w-4 spaces:h-4 spaces:rounded-full spaces:bg-canvas-2 spaces:shrink-0' />
						)}
						{leaseTerm && <span className='spaces:whitespace-nowrap'>{leaseTerm}</span>}
					</div>
				)}
			</div>
		)
	}

	return (
		<div className='spaces:@container spaces:flex spaces:flex-1 spaces:min-w-0 spaces:flex-col spaces:gap-4 spaces:@pricing-primary:flex-row spaces:@pricing-primary:items-center spaces:@pricing-primary:gap-8'>
			<div className='spaces:flex spaces:items-baseline spaces:gap-4 spaces:whitespace-nowrap'>
				<span className='spaces:text-14/16 spaces:font-default spaces:text-content-3'>{preText}</span>
				<span className='spaces:text-18/24 spaces:font-strong spaces:text-content-1'>{baseRent}</span>
				<span className='spaces:text-14/16 spaces:font-default spaces:text-content-3'>
					Base Rent{disclaimer}
				</span>
			</div>
			{leaseTerm && (
				<>
					<span className='spaces:hidden spaces:@pricing-primary:block spaces:w-4 spaces:h-4 spaces:rounded-full spaces:bg-canvas-2 spaces:shrink-0' />
					<span className='spaces:text-14/16 spaces:font-default spaces:text-content-3 spaces:whitespace-nowrap'>{leaseTerm}</span>
				</>
			)}
		</div>
	)
}
